// Single place that reads import.meta.env. Everything else imports `env` from here.
const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
  // Fail closed: only use the in-memory mock layer when VITE_USE_MOCKS is explicitly 'true'.
  useMocks: String(import.meta.env.VITE_USE_MOCKS ?? 'false') === 'true',
  appName: import.meta.env.VITE_APP_NAME || 'UPSC News Admin',
};

export default env;
